import { render, staticRenderFns } from "./webcomponent.vue?vue&type=template&id=e887f42c"
import script from "./webcomponent.vue?vue&type=script&lang=js"
export * from "./webcomponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports